import React from 'react';
import { Link } from 'react-router-dom'; // Link import karein
import styles from './Education.module.css';

const Education = ({ lang }) => {
  const data = {
    EN: {
      title: "Learning & Education",
      btn: "Read More Updates",
      items: [
        { id: 14, cat: " ", title: "AIOU Announces Fully-Funded Scholarships With Rs. 80,000 Monthly Stipend" },
        { id: 15, cat: "", title: "Punjab to Give Skill Training to 90,000 Students" },
        { id: 16, cat: "", title: "FPSC Announces New Jobs Under Digitalization Project" }
      ]
    },
    UR: {
      title: "تعلیم اور آگاہی",
      btn: "مزید اپڈیٹس پڑھیں",
      items: [
        { id: 14, cat: " ", title:"علامہ اقبال اوپن یونیورسٹی (AIOU) کا 80,000 روپے ماہانہ وظیفے کے ساتھ مکمل فنڈڈ اسکالرشپس کا اعلان۔"},
        { id: 15, cat: "", title: "پنجاب حکومت کا 90,000 طلبا کو ہنر سکھانے کا فیصلہ" },
        { id: 16, cat: "", title: "ایف پی ایس سی (FPSC) کا ڈیجیٹلائزیشن پروجیکٹ کے تحت نئی ملازمتوں کا اعلان" }
      ]
    }
  }[lang];

  return (
    <section className={styles.eduSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.gridContainer}>
        {/* Bada Card (ID 14) */}
        <Link to={`/news/${data.items[0].id}`} className={styles.eduCard} style={{ gridRow: 'span 2' }}>
          <img src="./Edu1.jpeg" alt="edu" />
          <div className={styles.cardContent}>
            <span>{data.items[0].cat}</span>
            <h3>{data.items[0].title}</h3>
          </div>
        </Link>
        
        {/* Chote Cards (ID 15 & 16) */}
        <Link to={`/news/${data.items[1].id}`} className={styles.eduCard}>
          <img src="./Edu3.jpeg" alt="edu" />
          <div className={styles.cardContent}>
            <span>{data.items[1].cat}</span>
            <h3>{data.items[1].title}</h3>
          </div>
        </Link>
        <Link to={`/news/${data.items[2].id}`} className={styles.eduCard}>
          <img src="Edu4.jpeg" alt="edu" />
          <div className={styles.cardContent}>
            <span>{data.items[2].cat}</span>
            <h3>{data.items[2].title}</h3>
          </div>
        </Link>
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Education;